// src/components/Footer.js
import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaGithub } from 'react-icons/fa';

function Footer() {
  return (
    <footer
      style={{
        background: '#1b263b',
        color: '#d9e6f2',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem 1rem',
        fontSize: '0.8rem',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        flexWrap: 'wrap',
      }}
    >
      <span>&copy; {new Date().getFullYear()} SamSoftix Smart Software Solutions</span>
      <div style={{ display: 'flex', gap: '0.8rem', marginTop: '0.3rem' }}>
        <a href="https://wa.me/923320472184" target="_blank" rel="noopener noreferrer" style={{ color: '#25D366' }}><FaWhatsapp /></a>
        <a href="https://www.facebook.com/samsoftix" target="_blank" rel="noopener noreferrer" style={{ color: '#1877f2' }}><FaFacebookF /></a>
        <a href="https://www.linkedin.com/company/samsoftix" target="_blank" rel="noopener noreferrer" style={{ color: '#0077b5' }}><FaLinkedinIn /></a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={{ color: '#1da1f2' }}><FaTwitter /></a>
        <a href="https://github.com" target="_blank" rel="noopener noreferrer" style={{ color: '#333' }}><FaGithub /></a>
      </div>
    </footer>
  );
}

export default Footer;
